import * as React from 'react';
import Chip from '@material-ui/core/Chip';

const CustomChip = (props) => {
    return <Chip {...props} />;
};

export { CustomChip as Chip };
